// extracted by mini-css-extract-plugin
export default {"body":"body-Sh3mvWYW","actions":"actions-Q0DX4gGJ","imageTitle":"imageTitle-fu090xT1","icon":"icon-SR6wbEQd","title":"title-arCrA3OE"};